<template>
  <div class="container">
    <div class="container pR" v-if="$store.state.isPc">
      <div class="left">
        <div style="width: 260px;height: 90px;" class="pR flexVC">
          <div class="title">趁早巡展</div>
          <div class="w100 pR title-line-box">
            <div class="titleLine"></div>
            <div class="titleLine-animation"
                 :class="currentIndex == 3 ? 'titleLine-animation-index' : '' "></div>
          </div>
        </div>
        <div class="content">{{content}}</div>
        <!--      <div class="btn-more-box" @mouseenter="moreEnter" @mouseleave="moreLeave">-->
        <!--        <div class="btn-more flexHC2" :class="isHover ? 'btn-more-hover' : ''">-->
        <!--        </div>-->
        <!--        <div class="btn-more-text flexHC2" :class="isHover ? 'CFFF' : 'C000'">-->
        <!--          <span>了解更多</span>-->
        <!--          <img :src="isHover ? whiteArrow : arrow"-->
        <!--               style="width: 15px;height: 11px;margin-left: 5px;">-->
        <!--        </div>-->
        <!--      </div>-->
      </div>
      <div class="swipe-control-box flexH">
        <div class="swipe-control pR">
          <transition-group :name="isDesc ? 'slide2' : 'slide'"
                            tag="ul">
            <li class="swipe-control-item" v-show="currentSwipeIndex == index"
                v-for="(item, index) in swipeData" :key="index">
              <div class="swipe-title">{{item.year}}</div>
              <div class="swipe-subtitle marT10">{{item.slogan}}</div>
            </li>
          </transition-group>
        </div>
        <div class="flexVC">
          <img :src="topArrow" class="swipe-arrow" @click="changeClick(1)">
          <img :src="bottomArrow" class="swipe-arrow" @click="changeClick(2)">
        </div>
      </div>
      <div class="right flexWrap2">
        <div v-for="(item, index) in swipeData">
          <el-image
            :class="childIndex == 3 || childIndex == 0 ? 'img-style-2' : 'img-style-2'"
            class="marT10 marR15 change-right"
            v-for="(child, childIndex) in item.imgs"
            v-show="currentSwipeIndex == index"
            :src="child"
            :fit="cover"></el-image>
        </div>
      </div>
    </div>

    <!-- 移动端 -->
    <div class="container-m pR flexVC2" v-if="!$store.state.isPc">
      <div style="width: 1.9rem;height: 0.6rem;" class="pR flexVC2">
        <div class="title-m">趁早巡展</div>
        <div class="w100 pR title-line-box-m">
          <div class="titleLine-m"></div>
          <div class="titleLine-animation-m"
               :class="currentIndex == 3 ? 'titleLine-animation-index-m' : '' "></div>
        </div>
      </div>
      <div class="content-m flexHC2" style="margin-top: 0.4rem;">{{content}}</div>
      <div class="w100m pR flexVC" style="margin-top: 0.4rem;">
        <div class="swipe-box pR">
          <div v-for="(item, index) in swipeData">
            <img :src="child"
                 v-for="(child, childIndex) in item.imgs"
                 v-show="currentSwipeIndex == index"
                 class=" marR15m change-right"
                 :class="childIndex == 3 || childIndex == 0 ? 'img-style-2-m' : 'img-style-2-m'"/>
          </div>

        </div>
        <div class="swipe-control-box-m flexH">
          <div class="swipe-control-m pR ">
            <transition-group :name="isDesc ? 'slide2' : 'slide'"
                              tag="ul">
              <li class="swipe-control-item-m" v-show="currentSwipeIndex == index"
                  v-for="(item, index) in swipeData" :key="index">
                <div class="swipe-title-m">{{item.year}}</div>
                <div class="swipe-subtitle-m marT10m">{{item.slogan}}</div>
              </li>
            </transition-group>
          </div>
          <img :src="leftArrow" class="left-arrow-m" @click="changeClick(1)">
          <img :src="rightArrow" class="right-arrow-m" @click="changeClick(2)">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import whiteArrow from '@/assets/images/icon_home_right_arrow_white.png'
  import arrow from '@/assets/images/icon_home_right_arrow.png'
  import topArrow from '@/assets/images/icon_top_arrow.png'
  import bottomArrow from '@/assets/images/icon_bottom_arrow.png'
  import leftArrow from '@/assets/images/icon_white_left_arrow.png'
  import rightArrow from '@/assets/images/icon_white_right_arrow.png'
  import {swipeTourData} from '@/utils/staticData'
  import {debounce} from '@/utils/tools'

  export default {
    name: "ActivityThird",
    props: ["currentIndex"],
    data() {
      return {
        content: '从2019年开始，趁早开启了全国文化巡展，期待通过各地的巡展见到更多的趁早星人，交流和见证大家彼此多年的变化',
        isHover: false,
        isShow: true,
        isDesc: false,
        whiteArrow: whiteArrow,
        arrow: arrow,
        topArrow: topArrow,
        bottomArrow: bottomArrow,
        leftArrow: leftArrow,
        rightArrow: rightArrow,
        homeTime: [],
        swipeData: [],
        currentSwipeData: {},
        currentSwipeIndex: 0,
        cover: 'cover',
        timer: {},
      }
    },

    mounted() {
      this.swipeData = swipeTourData.reverse()
      this.currentSwipeData = swipeTourData[0]
      console.log('asd--swipeData---', swipeTourData)
      this.autoPlay()
    },

    watch: {
      currentIndex(val) {
      }
    },


    methods: {
      autoPlay() {
        this.timer = setInterval(() => {
          this.currentSwipeIndex++;
          if (this.currentSwipeIndex > this.swipeData.length - 1) {
            this.currentSwipeIndex = 0;
          }
          this.isDesc = false
          this.currentSwipeData = swipeTourData[this.currentSwipeIndex]
        }, 5000);
      },
      changeClick: debounce(function (type) {
        console.log(this.currentSwipeData)
        if (type[0] == 1) {
          this.currentSwipeIndex--
          this.isDesc = true
          if (this.currentSwipeIndex < 0) {
            this.currentSwipeIndex = this.swipeData.length - 1;
          }
          clearInterval(this.timer)
          this.autoPlay()
        } else {
          this.currentSwipeIndex++
          this.isDesc = false
          if (this.currentSwipeIndex > this.swipeData.length - 1) {
            this.currentSwipeIndex = 0;
          }
          clearInterval(this.timer)
          this.autoPlay()
        }
      }, 500),

      moreEnter(e) {
        this.isHover = true
        // console.log('111111111111111111', this.$refs.more.$el)
        // this.$refs.more.$el.style.cssText = '-webkit-animation: fadeIn 0.3s linear 1;animation: fadeIn 0.3s linear 1;animation-fill-mode: forwards;';
        // this.$refs.moreTest.$el.style.cssText = 'color: #fff;'
      },
      moreLeave(e) {
        this.isHover = false
        // console.log('222222222222222222222')
        // this.$refs.more.$el.style.cssText = 'width: 230px;height: 51px;color: #FFFFFF;';
      },
    },
  }
</script>

<style scoped>

  .left {
    position: absolute;
    top: 40%;
    left: 0;
    transform: translate(0, -47%);
    padding-left: 7.71vw;
  }

  .title {
    width: 260px;
    font-size: 60px;
    font-family: SourceHanSerifCN-Heavy, SourceHanSerifCN;
    font-weight: 800;
    color: rgba(0, 0, 0, 0.85);
    position: absolute;
    left: 50%;
    margin-left: -130px;
    top: 0;
    z-index: 10;
  }

  .title-line-box {
    width: 245px;
    position: absolute;
    bottom: 0px;
    left: 0;
  }

  .titleLine {
    width: 100%;
    height: 26px;
    background: #FFCCC0;
  }

  .titleLine-animation {
    width: 100%;
    height: 26px;
    background: #FFFFFF;
    position: absolute;
    top: 0;
    left: 0;
  }

  .content {
    max-width: 424px;
    min-width: 240px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 30px;
    margin-top: 60px;
    text-align: justify;
  }

  .right {
    width: 800px;
    position: absolute;
    right: 7.71vw;
    bottom: 5.56vh;
  }

  .img-style-1 {
    width: 512px;
    height: 344px;
  }

  .img-style-2 {
    width: 248px;
    height: 344px;
  }

  /*.img-style-1:hover:after{*/
  /*  width: 512px;*/
  /*  height: 344px;*/
  /*  background: rgba(0,0,0,.8);*/
  /*  content: '了解更多';*/
  /*  position: absolute;*/
  /*  left: 0;*/
  /*  top: 0;*/
  /*  display: flex;*/
  /*  align-items: center;*/
  /*  justify-content: center;*/
  /*  font-size: 18px;*/
  /*  font-family: PingFangSC-Regular, PingFang SC;*/
  /*  font-weight: 400;*/
  /*  color: #FFFFFF;*/
  /*}*/
  /*.img-style-2:hover:after{*/
  /*  width: 248px;*/
  /*  height: 344px;*/
  /*  background: rgba(0,0,0,.8);*/
  /*  content: '了解更多';*/
  /*  position: absolute;*/
  /*  left: 0;*/
  /*  top: 0;*/
  /*  display: flex;*/
  /*  align-items: center;*/
  /*  justify-content: center;*/
  /*  font-size: 18px;*/
  /*  font-family: PingFangSC-Regular, PingFang SC;*/
  /*  font-weight: 400;*/
  /*  color: #FFFFFF;*/
  /*}*/


  .swipe-control-box {
    position: absolute;
    left: 0;
    bottom: 5.56vh;
  }

  .swipe-control {
    width: 408px;
    height: 102px;
    background: #000000;
    overflow: hidden;
  }

  .swipe-control-item {
    position: absolute;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .swipe-arrow {
    width: 36px;
    height: 36px;
  }

  .swipe-title {
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 24px;
    margin-left: 7.71vw;
  }

  .swipe-subtitle {
    font-size: 18px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 200;
    color: #FFFFFF;
    margin-left: 7.71vw;
  }


  .slide-enter-active, .slide-leave-active {
    transition: all 1.2s;
  }

  .slide-enter {
    opacity: 0;
    transform: translateY(100%);
  }

  .slide-leave-active {
    opacity: 0;
    transform: translateY(-100%);
  }

  .slide2-enter-active, .slide2-leave-active {
    transition: all 1.2s;
  }

  .slide2-enter {
    opacity: 0;
    transform: translateY(-100%);
  }

  .slide2-leave-active {
    opacity: 0;
    transform: translateY(100%);
  }

  .fold-enter-active {
    animation-name: fold-in;
    animation-duration: 2s;
  }

  .fold-leave-active {
    animation-name: fold-out;
    animation-duration: 2s;
  }

  @keyframes fold-in {
    0% {
      transform: translateY(100%);
    }
    100% {
      transform: translateY(0);
      /*transform: scale(1);*/
    }
  }

  @keyframes fold-out {
    0% {
      transform: translateY(0);
      /*transform: scale(1);*/
    }
    100% {
      transform: translateY(-100%);
      /*transform: scale(.1);*/
    }
  }

  .btn-more {
    width: 230px;
    height: 51px;
    color: #FFFFFF;
    /*overflow: hidden;*/
  }

  .btn-more-box {
    width: 230px;
    height: 51px;
    margin-top: 60px;
    border: 1px solid #000000;
    color: #000000;
    position: relative;
  }

  .btn-more-text {
    width: 230px;
    height: 51px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 200;
    font-size: 16px;
    font-weight: 600;
  }


  .btn-more:after {
  }

  .btn-more-hover {
    width: 230px;
    background: #000000;
    border: 1px solid #000000;
    -webkit-animation: fadeIn 0.3s linear 1; /*鼠标hover时，i图标旋转,infinite表示动画无限循环*/
    animation: fadeIn 0.3s linear 1;
    animation-fill-mode: forwards;
  }

  .titleLine-animation-index {
    -webkit-animation: spin 0.8s linear 1; /*鼠标hover时，i图标旋转,infinite表示动画无限循环*/
    animation: spin 0.8s linear 1;
    animation-fill-mode: forwards;
    /*background: #ff0000;*/
  }

  .change-right {
    -webkit-animation: change 1.5s linear 1; /*鼠标hover时，i图标旋转,infinite表示动画无限循环*/
    animation: change 1.5s linear 1;
    animation-fill-mode: forwards;
  }

  /*定义动画*/
  @-webkit-keyframes spin { /*兼容性写法。spin是关键帧的动画名称*/
    from { /*动画起始状态*/
      -webkit-transform: translateX(0px);
    }
    to { /*动画结束状态*/
      -webkit-transform: translateX(245px);
    }
  }

  @keyframes spin {
    from {
      transform: translateX(0px);
    }
    to {
      transform: translateX(245px);
    }
  }


  /*定义动画*/
  @-webkit-keyframes change { /*兼容性写法。spin是关键帧的动画名称*/
    from { /*动画起始状态*/
      /*transform: scale(1);*/
      opacity: 1;
    }
    to { /*动画结束状态*/
      /*transform: scale(.9);*/
      opacity: 0.3;
    }
  }

  @keyframes change {
    from {
      /*transform: scale(.9);*/
      opacity: 0.3;
    }
    to {
      /*transform: scale(1);*/
      opacity: 1;
    }
  }

  @-webkit-keyframes fadeIn { /*兼容性写法。spin是关键帧的动画名称*/
    from {
      width: 0px;
      /*transform: translateX(0px);*/
      background: #FFFFFF;
    }
    to {
      width: 100%;
      /*transform: translateX(240px);*/
      background: #000000;
    }
  }

  @keyframes fadeIn {
    from {
      width: 0px;
      /*transform: translateX(0px);*/
      background: #FFFFFF;
      border: 1px solid #000000;
    }
    to {
      width: 100%;
      /*transform: translateX(240px);*/
      background: #000000;
      border: 1px solid #000000;
    }
  }


  @media screen and (max-width: 1440px) {

    .right {
      width: 650px;
      position: absolute;
      right: 7.41vw;
      bottom: 5.56vh;
    }

    .img-style-1 {
      width: 409.6px;
      height: 275.2px;
    }

    .img-style-2 {
      width: 198.4px;
      height: 275.2px;
    }

  }


  @media screen and (max-height: 800px) {

    .right {
      width: 570px;
      position: absolute;
      right: 7.41vw;
      bottom: 5.56vh;
    }

    .img-style-1 {
      width: 358.4px;
      height: 240px;
    }

    .img-style-2 {
      width: 173.6px;
      height: 240px;
    }
  }



  @media screen and (max-width: 1300px) {

    .content {
      max-width: 350px;
      min-width: 240px;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.85);
      line-height: 30px;
      margin-top: 60px;
    }

    .right {
      width: 513px;
      position: absolute;
      right: 7.41vw;
      bottom: 5.56vh;
    }

    .img-style-1 {
      width: 323px;
      height: 216px;
    }

    .img-style-2 {
      width: 156px;
      height: 216px;
    }
  }

  /**********************************  移动端********************************************/

  .content-m {
    width: 6.54rem;
    font-size: 0.26rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    line-height: 0.44rem;
  }

  .title-m {
    width: 100%;
    font-size: 0.4rem;
    font-family: SourceHanSerifCN-Heavy, SourceHanSerifCN;
    font-weight: bolder;
    color: rgba(0, 0, 0, 0.85);
    position: absolute;
    text-align: center;
    left: 0;
    top: 0;
    z-index: 10;
  }

  .title-line-box-m {
    width: 100%;
    position: absolute;
    bottom: 0px;
    left: 0;
  }

  .titleLine-m {
    width: 100%;
    height: 0.16rem;
    background: #FFCCC0;
  }

  .titleLine-animation-m {
    width: 100%;
    height: 0.16rem;
    background: #f0f2f5;
    position: absolute;
    top: 0;
    left: 0;
  }

  .titleLine-animation-index-m {
    -webkit-animation: spinm 0.8s linear 1; /*鼠标hover时，i图标旋转,infinite表示动画无限循环*/
    animation: spinm 0.8s linear 1;
    animation-fill-mode: forwards;
    /*background: #ff0000;*/
  }


  .btn-more-box-m {
    width: 2.02rem;
    height: 0.64rem;
    border-radius: 4px;
    border: 1px solid #000000;
    margin-top: 0.1rem;
    font-size: 0.24rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    cursor: pointer;
    z-index: 500;
  }

  .btn-more-text {
    width: 230px;
    height: 51px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 200;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
  }



  .img-style-1-m {
    width: 4.10rem;
    height: 2.78rem;
  }

  .img-style-2-m {
    width: 2.02rem;
    height: 2.78rem;
  }

  .swipe-box{
    width: 6.60rem;
  }


  .swipe-control-box-m {
    position: absolute;
    left: 0;
    bottom: -0.8rem;
    z-index: 500;
  }

  .swipe-control-m {
    width: 5.48rem;
    height: 1.36rem;
    background: #000000;
    overflow: hidden;
  }

  .swipe-control-item-m {
    width: 3.8rem;
    position: absolute;
    left: 50%;
    margin-left: -1.9rem;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .swipe-title-m {
    text-align: center;
    font-size: 0.28rem;
    font-family: Poppins;
    color: #FFFFFF;
    font-weight: bold;
  }

  .swipe-subtitle-m {
    text-align: center;
    font-size: 0.26rem;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #FFFFFF;
  }

  .left-arrow-m{
    position: absolute;
    width: 0.14rem;
    height: 0.23rem;
    left: 0.48rem;
    top: 50%;
    margin-top: -0.13rem;
  }

  .right-arrow-m{
    position: absolute;
    width: 0.14rem;
    height: 0.23rem;
    right:  0.48rem;;
    top: 50%;
    margin-top: -0.13rem;
  }

  /*定义动画*/
  @-webkit-keyframes spinm { /*兼容性写法。spin是关键帧的动画名称*/
    from { /*动画起始状态*/
      -webkit-transform: translateX(0%);
    }
    to { /*动画结束状态*/
      -webkit-transform: translateX(100%);
    }
  }

  @keyframes spinm {
    from {
      -webkit-transform: translateX(0%);
    }
    to {
      -webkit-transform: translateX(100%);
    }
  }


  .fontE4 {
    display: -webkit-box;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .marT20m {
    margin-top: 0.2rem;
  }

  .marT15m {
    margin-top: 0.15rem;
  }

  .marT10m {
    margin-top: 0.1rem;
  }

  .marR15m{
    margin-right: 0.15rem;
  }

  .marT32m {
    margin-top: 0.32rem;
  }

  .marL20m {
    margin-left: 0.2rem;
  }


  /*  *************************************************************************************/



</style>



// WEBPACK FOOTER //
// src/page/activity/components/ActivityThird.vue